/* mm-englisch.js - Sprachschicht fuer alles, was die eigenen Bausteine schreiben.
 *
 * 05.09.2026, Mert: "englisch machen fuer nicht dach."
 * DACH (Deutschland, Oesterreich, Schweiz) bleibt deutsch, alle uebrigen
 * Laender bekommen dieselbe Seite auf Englisch.
 *
 * WARUM DIESE SCHICHT UND NICHT 41 EINZELNE DATEIEN
 * Der Laden hat 41 eigene Bausteine (mm-*.js), die ihre Texte fest im Code
 * tragen und ihre Abschnitte selbst per JavaScript bauen. Shopifys eigene
 * Uebersetzung greift dort nicht - sie kennt nur Liquid und die Sprachdateien.
 * Jede Datei einzeln zweisprachig zu machen hiesse, 41 gewachsene Bausteine
 * anzufassen; jeder Eingriff waere ein Risiko fuer eine Sektion, die heute
 * laeuft. Diese Schicht sitzt stattdessen davor: sie beobachtet, was in die
 * Seite geschrieben wird, und tauscht die Saetze aus, waehrend sie entstehen.
 *
 * REIHENFOLGE - DER GRUND, WARUM DAS UEBERHAUPT SAUBER AUFGEHT
 * mm-textanim.js zerlegt Saetze in einzelne Woerter (span.mmTA), damit sie
 * nacheinander einblenden koennen. Es laeuft als LETZTES Skript und liest
 * dabei den Text, der dann gerade in der Seite steht. Diese Datei laeuft als
 * ERSTES, ohne defer, noch im head. Ihr Beobachter haengt also schon, bevor
 * irgendein Baustein etwas baut - der Satz ist englisch, bevor er zerlegt
 * wird, und die Wortreihenfolge stimmt von allein. Andersherum muesste man
 * englische Woerter in deutsche Wortkaesten einsortieren, und das geht bei
 * unterschiedlicher Satzstellung nicht auf.
 *
 * ZWEI BAUSTEINE ZERLEGEN SELBST
 * mm-kannst.js und mm-aufdeck.js teilen ihre Saetze schon beim Bauen in
 * Woerter. Bei ihnen greift der Beobachter zu spaet. Sie rufen darum
 * window.mmT() auf ihren Satz auf, bevor sie ihn zerlegen - das ist die
 * einzige Aenderung, die an bestehenden Bausteinen noetig war.
 *
 * WAS BEWUSST NICHT UEBERSETZT WIRD
 * Produkttitel. Die uebersetzt Shopify selbst, und mehrere Bausteine
 * (mm-upsellhilfe, mm-ziel2, mm-komplett) suchen Produkte ueber ihren Titel.
 * Wuerde diese Schicht sie zusaetzlich austauschen, faende die Suche nichts
 * mehr - der Warenkorb bliebe leer, ohne Fehlermeldung.
 *
 * KEIN DAUERLAUF (feste Regel 23.08.2026)
 * Der Beobachter rechnet nichts fortlaufend. Er wird nur wach, wenn
 * tatsaechlich Knoten dazukommen, und schlaegt in einer Nachschlagetabelle
 * nach. Keine Schleife, kein requestAnimationFrame, kein Zeitgeber.
 */
(function () {
  'use strict';

  /* Welche Sprache liefert der Laden gerade aus. html[lang] kommt aus
     request.locale.iso_code, Shopify.locale ist der Rueckfall. */
  function sprache() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (!l && window.Shopify && window.Shopify.locale) {
      l = String(window.Shopify.locale).toLowerCase();
    }
    return l;
  }

  var L = sprache();

  /* mmT gibt es IMMER, auch auf der deutschen Seite - sonst muessten die
     aufrufenden Bausteine jedes Mal pruefen, ob es die Funktion schon gibt. */
  window.mmT = function (t) { return t; };

  /* 06.09.2026: Sobald Englisch veroeffentlicht ist, liegt die Startseite nicht
     mehr nur unter "/", sondern auch unter "/en/", "/en-eu/" und "/en-int/".
     Sechs Bausteine (mm-aktion, mm-aufdeck, mm-beutel-v2, mm-morph, mm-ziel2,
     mm-held) pruefen aber hart auf "/" und bauten ihre Sektion dort schlicht
     nicht - die Aufdeck-Sektion fehlte auf der englischen Startseite komplett.
     Diese Pruefung kennt die Sprachordner des Ladens und liegt hier, weil sie
     auf der deutschen Seite genauso gebraucht wird.

     Bewusst NICHT /^\/[a-z]{2}\/$/: das traefe auch eine echte Seite mit
     zweibuchstabigem Pfad. Und der Zusatz nach dem Bindestrich ist bewusst
     NICHT auf zwei Zeichen begrenzt - ein Markt-Unterordner kann laenger
     heissen. Genau daran ist "/en-int/" (Markt Uebersee) am 06.09.2026 zuerst
     gescheitert: dort baute keine der sechs Sektionen. */
  window.mmStartseite = function () {
    return /^\/(?:(?:de|en|it|fr|ar|es)(?:-[a-z0-9]+)?\/?)?$/i
      .test(window.location.pathname);
  };

  /* Deutsch bleibt deutsch. Ohne erkannte Sprache ebenfalls nichts anfassen:
     lieber die Ausgangssprache stehen lassen als raten. */
  if (!L || L.indexOf('de') === 0) return;

  var W = {
    "In den Warenkorb": "Add to cart",
    "Abo in den Warenkorb": "Add subscription to cart",
    "Vorrat sichern": "Get your supply",
    "Produkt ansehen": "View product",
    "Magic Fruit ansehen": "View Magic Fruit",
    "Zum Produkt \u2192": "To the product \u2192",
    "Zum Video": "Watch the video",
    "Video abspielen": "Play video",
    "N\u00e4chstes Bild": "Next image",
    "Vorheriges Bild": "Previous image",
    "Suche leeren": "Clear search",
    "In den Fragen suchen": "Search the questions",
    "Such einfach: m\u00fcde, Sport, Preis \u2026": "Just search: tired, sport, price \u2026",
    "H\u00e4ufig gestellte Fragen ansehen": "See frequently asked questions",
    "Direkt per WhatsApp": "Straight to WhatsApp",
    "Zurzeit nicht verf\u00fcgbar": "Currently unavailable",
    "Wird hinzugef\u00fcgt \u2026": "Adding \u2026",
    "Im Warenkorb \u2713": "In your cart \u2713",
    "Bitte noch einmal": "Please try again",
    "Kennst du das": "Sound familiar?",
    "Vier S\u00e4tze, die wir jeden Tag h\u00f6ren": "Four sentences we hear every day",
    "Und was wirklich dahintersteckt \u2014 ohne Sch\u00f6nreden.": "And what is really behind them \u2014 with no sugar-coating.",
    "Ich esse doch genug": "But I do eat enough",
    "Der Satz, den wir am h\u00e4ufigsten h\u00f6ren. Meistens stimmt er sogar \u2014 nur reicht \u201egenug\" nicht, wenn der K\u00f6rper mehr verbraucht, als auf dem Teller liegt. Das Problem ist selten das falsche Essen, sondern die fehlende Lust auf die Menge.": "The sentence we hear most often. Usually it is even true \u2014 but \u201cenough\u201d is not enough when your body burns more than what is on the plate. The problem is rarely the wrong food. It is not fancying the amount.",
    "Es liegt am Appetit": "It comes down to appetite",
    "Kaum eigene Kalorien": "Barely any calories of its own",
    "Ich trainiere und nichts passiert": "I train and nothing happens",
    "Training erh\u00f6ht den Verbrauch. Wer danach keinen Hunger hat, kommt gar nicht erst auf die Menge, die der Plan verlangt. Genau da setzt ein Appetitanreger an \u2014 er ersetzt kein Training und keine Mahlzeit.": "Training raises what you burn. If you have no hunger afterwards, you never reach the amount your plan calls for. That is exactly where an appetite stimulant comes in \u2014 it replaces neither the training nor a meal.",
    "Ein Stick vor der Mahlzeit": "One stick before the meal",
    "30 Beutel, 5 g": "30 sachets, 5 g",
    "Morgens kriege ich nichts runter": "I cannot get anything down in the morning",
    "Der h\u00e4ufigste Ber\u00fchrungspunkt. Magic Milk wird vor einer Mahlzeit getrunken, nicht statt einer. Zehn pflanzliche Zutaten und Milchpulver, kein Koffein, kein Zuckerschub.": "The most common starting point. Magic Milk is drunk before a meal, not instead of one. Ten plant-based ingredients and milk powder, no caffeine, no sugar rush.",
    "Vor dem Essen": "Before eating",
    "10 Zutaten, kein Koffein": "10 ingredients, no caffeine",
    "Ich habe schon alles probiert": "I have tried everything already",
    "Dann sagen wir es offen: Eine Garantie gibt es nicht. Wir empfehlen mindestens drei Monate, weil sich in k\u00fcrzerer Zeit selten etwas zeigt. Den Rest machst du am Tisch \u2014 wir liefern nur den Ansto\u00df.": "Then we will say it plainly: there is no guarantee. We recommend at least three months, because less time rarely shows anything. The rest you do at the table \u2014 we only give the nudge.",
    "Keine Garantie": "No guarantee",
    "Ab 3 Monaten": "From 3 months",
    "ab 3 Monaten": "from 3 months",
    "Mehr zum Produkt": "More about the product",
    "Wof\u00fcr die Leute es nehmen": "What people take it for",
    "Drei Gr\u00fcnde, drei ehrliche Antworten. Tipp eines an, dann klappt es auf.": "Three reasons, three honest answers. Tap one and it opens.",
    "Der Kern": "The core",
    "Magic Milk ist ein Appetitanreger \u2014 kein Essen und kein Mahlzeitersatz. Es soll die Lust aufs Essen zur\u00fcckbringen, den Rest machst du am Tisch. Eine Garantie gibt es nicht, das sagen wir offen. Empfohlen sind mindestens drei Monate.": "Magic Milk is an appetite stimulant \u2014 not food and not a meal replacement. It is meant to bring back the appetite for eating; the rest you do at the table. There is no guarantee, and we say so openly. At least three months are recommended.",
    "Appetitanreger": "Appetite stimulant",
    "kein Mahlzeitersatz": "not a meal replacement",
    "Durch den Tag": "Through the day",
    "Zehn pflanzliche Zutaten und Milchpulver, sonst nichts. Kein Koffein, kein Zuckerschub, kein Aufputschen. Viele beschreiben es als ruhiges, gleichm\u00e4\u00dfiges Gef\u00fchl \u00fcber den Tag \u2014 wie es sich bei dir anf\u00fchlt, merkst du selbst.": "Ten plant-based ingredients and milk powder, nothing else. No caffeine, no sugar rush, no buzz. Many describe it as a calm, even feeling through the day \u2014 how it feels for you, you will notice yourself.",
    "10 Zutaten": "10 ingredients",
    "ohne Koffein": "no caffeine",
    "eine Portion am Tag": "one serving a day",
    "F\u00fcr Sportler": "For athletes",
    "Wer hart trainiert, verbrennt viel \u2014 und muss entsprechend viel essen. Daran scheitern die meisten, nicht am Training. Magic Milk bringt dir selbst kaum Kalorien, sondern soll dir helfen, \u00fcberhaupt Appetit auf die Menge zu bekommen, die dein Plan verlangt.": "Train hard and you burn a lot \u2014 so you have to eat accordingly. That is where most people fail, not at the training. Magic Milk brings you barely any calories itself; it is meant to help you build the appetite for the amount your plan calls for.",
    "30 Portionsbeutel": "30 single sachets",
    "5 g je Beutel": "5 g per sachet",
    "vor einer Mahlzeit": "before a meal",
    "APPETIT": "APPETITE",
    "ENERGIE": "ENERGY",
    "Magic Milk ist": "Magic Milk is",
    "Was Magic Milk ist": "What Magic Milk is",
    "ein Appetitanreger.": "an appetite stimulant.",
    "zehn pflanzliche Zutaten.": "ten plant-based ingredients.",
    "ein Stick vor dem Essen.": "one stick before eating.",
    "ohne Koffein, ohne Zuckerschub.": "no caffeine, no sugar rush.",
    "kein Mahlzeitersatz.": "not a meal replacement.",
    "keine Garantie \u2014 das sagen wir offen.": "no guarantee \u2014 and we say so openly.",
    "Kein Hunger? Kein Appetit? Zunehmen f\u00e4llt dir schwer? Ein Stick am Tag, in Wasser einger\u00fchrt, vor der Mahlzeit. Drei\u00dfig Portionen, vier Sorten. Du w\u00e4hlst.": "No hunger? No appetite? Putting on weight is hard? One stick a day, stirred into water, before your meal. Thirty portions, four flavours. You choose.",
    "Alle vier Sorten": "All four flavours",
    "Alle vier Sorten im Komplettset": "All four flavours in the complete set",
    "Das Komplettset": "The Complete Set",
    "Einmal alles probieren \u2014 statt sich blind zu entscheiden": "Try everything once \u2014 instead of choosing blind",
    "Vier Packungen, vier Geschmacksrichtungen, vier Monate Vorrat. F\u00fcr alle, die noch nicht wissen, welche Sorte ihre ist.": "Four packs, four flavours, four months of supply. For anyone who does not yet know which one is theirs.",
    "Jede Sorte einmal \u2014 Standard, Strawberry, Nuss & Creamy und Magic Fruit. Jede Packung 30 Sticks, einer am Tag.": "Every flavour once \u2014 Standard, Strawberry, Nut & Creamy and Magic Fruit. Each pack 30 sticks, one a day.",
    "Neutral im Geschmack": "Neutral in taste",
    "Nussig und mild": "Nutty and mild",
    "Fruchtig, von Florea": "Fruity, by Florea",
    "Nuss & Creamy": "Nut & Creamy",
    "Preise und Verf\u00fcgbarkeit direkt aus dem Shop. Versand aus Deutschland.": "Prices and availability come straight from the shop. Shipped from Germany.",
    "Nur das Original": "The original only",
    "Bei uns laborgepr\u00fcft": "Lab-tested with us",
    "Bei uns laborgepr\u00fcft.": "Lab-tested with us.",
    "Unser FOR X5 wurde von einem amtlichen, akkreditierten Labor untersucht. Alle gepr\u00fcften verbotenen Stoffe lagen unter der Nachweisgrenze.": "Our FOR X5 was examined by an official, accredited laboratory. Every banned substance tested for was below the detection limit.",
    "Die Au\u00dfenverpackung kann echt aussehen \u2014 und der Inhalt trotzdem eine ungepr\u00fcfte Kopie sein. Am Karton allein erkennst du es nicht.": "The outer packaging can look genuine \u2014 and the contents still be an untested copy. The box alone will not tell you.",
    "Die Au\u00dfenverpackung kann echt aussehen \u2014 und der Inhalt trotzdem eine ungepr\u00fcfte Kopie sein.": "The outer packaging can look genuine \u2014 and the contents still be an untested copy.",
    "Am Karton allein erkennst du es nicht.": "The box alone will not tell you.",
    "Der Preis verr\u00e4t es": "The price gives it away",
    "Auff\u00e4llig billig ist kein Schn\u00e4ppchen, sondern das h\u00e4ufigste Zeichen f\u00fcr eine F\u00e4lschung.": "Strikingly cheap is not a bargain \u2014 it is the most common sign of a fake.",
    "Ohne Berechtigung, ohne Pr\u00fcfung": "No authorisation, no testing",
    "H\u00e4ndler ohne Bezug zum Hersteller k\u00f6nnen keine Laborberichte vorlegen. Von diesen Angeboten distanzieren wir uns.": "Sellers with no link to the maker cannot produce lab reports. We distance ourselves from those offers.",
    "Keine Haftung von uns": "No liability from us",
    "F\u00fcr Ware, die nicht \u00fcber uns gekauft wurde, \u00fcbernehmen wir keine Haftung und keine Gew\u00e4hrleistung.": "For goods not bought through us we accept no liability and give no warranty.",
    "Dir ist etwas untergekommen, das wie Magic Milk aussieht, aber nicht von uns stammt? Schreib uns an info@magicmilk.de \u2014 wir gehen dem nach.": "Come across something that looks like Magic Milk but is not from us? Write to info@magicmilk.de \u2014 we will look into it.",
    "ORIGINAL SECURITY \u2014 der Streifen auf jeder Packung": "ORIGINAL SECURITY \u2014 the strip on every pack",
    "ORIGINAL SECURITY im Hologramm": "ORIGINAL SECURITY in the hologram",
    "FOR X5 \u2014 Herstellerzeichen": "FOR X5 \u2014 maker\u2019s mark",
    "Feines Wellenraster": "Fine wave pattern",
    "Wiederholt sich \u00fcber den Streifen": "Repeats across the strip",
    "Versiegelt \u2014 und die Pr\u00fcflinie zeigt, was drin ist": "Sealed \u2014 and the check line shows what is inside",
    "Das Siegel aus der N\u00e4he \u2014 daran erkennst du es": "The seal up close \u2014 this is how you spot it",
    "Gleiche Pr\u00fcfung, gleiche Herkunft \u2014 jede Sorte": "Same testing, same origin \u2014 every flavour",
    "Magic Milk FOR X5 Standard, Packung von vorne": "Magic Milk FOR X5 Standard, pack seen from the front",
    "Magic Milk FOR X5 Strawberry, Packung von vorne": "Magic Milk FOR X5 Strawberry, pack seen from the front",
    "Nahaufnahme des ORIGINAL-SECURITY-Hologramms auf der Magic-Milk-Packung": "Close-up of the ORIGINAL SECURITY hologram on the Magic Milk pack",
    "Die h\u00e4ufigsten Fragen": "The most common questions",
    "Gefragt und beantwortet": "Asked and answered",
    "H\u00e4ufige Fragen": "Common questions",
    "F\u00fcr dich": "For you",
    "Passt das \u00fcberhaupt zu mir?": "Is this even right for me?",
    "Anwendung": "How to use",
    "Einnahme, Pausen, Aufh\u00f6ren": "Taking it, breaks, stopping",
    "Inhalt & Sicherheit": "Contents & safety",
    "Was drin ist und was es macht": "What is in it and what it does",
    "Original & Preis": "Original & price",
    "Echtheit, F\u00e4lschungen, Preis": "Authenticity, fakes, price",
    "Dazu steht hier noch nichts. Schreib uns an info@magicmilk.de \u2014 wir antworten dir direkt.": "Nothing on that here yet. Write to info@magicmilk.de \u2014 we will answer you directly.",
    "Warum macht Magic Milk am Anfang m\u00fcde \u2014 illustrierte Darstellung der Anfangsphase": "Why Magic Milk makes you tired at first \u2014 illustration of the early phase",
    "Illustrative Darstellung. Zum Vergr\u00f6\u00dfern antippen.": "Illustration. Tap to enlarge.",
    "F\u00fcr dein Ziel:": "For your goal:",
    "Zunehmen oder Abnehmen": "Gaining or losing weight",
    "Gut zu wissen": "Good to know",
    "Lieferzeit": "Delivery time",
    "1 bis 3 Werktage": "1 to 3 working days",
    "Express und Nachnahme stehen im Checkout zur Wahl.": "Express and cash on delivery can be chosen at checkout.",
    "Immer verfolgbar": "Always trackable",
    "Die Sendungsnummer kommt automatisch per E-Mail.": "The tracking number arrives automatically by email.",
    "Innerhalb Deutschlands, nach \u00dcbergabe an den Versand.": "Within Germany, after handover to the carrier.",
    "Widerruf": "Right of withdrawal",
    "14 Tage Zeit": "14 days",
    "Ohne Angabe von Gr\u00fcnden \u2014 \u00fcber unser Widerrufscenter.": "No reasons needed \u2014 through our withdrawal centre.",
    "Zahlung": "Payment",
    "Karte, PayPal, Rechnung": "Card, PayPal, invoice",
    "Klarna, Nachnahme und internationale Zahlarten ebenso m\u00f6glich.": "Klarna, cash on delivery and international payment methods are available too.",
    "support@magicmilk.de oder +49 15565 408252.": "support@magicmilk.de or +49 15565 408252.",
    "Immer da, wenn du ihn brauchst": "Always there when you need it",
    "Kaufart": "Purchase type",
    "Einmalig": "One-off",
    "Abo": "Subscription",
    "Jeden Monat": "Every month",
    "Im Abo \u2013 jederzeit k\u00fcndbar": "Subscription \u2013 cancel any time",
    "Dein Monatsvorrat": "Your monthly supply",
    "Eine Packung, einmalig": "One pack, one-off",
    "1 Monat": "1 month",
    "3 Monate": "3 months",
    "Halbes Jahr": "Half a year",
    "Meistgenommen": "Most chosen",
    "Beliebt": "Popular",
    "Bester Preis je Monat": "Best price per month",
    "je Monat": "per month",
    "Wie viel": "How much",
    "Wie viele Packungen, welche Sorte": "How many packs, which flavour",
    "Eine Packung sind 30 Sticks \u2013 einer am Tag, also genau ein Monat. Wer mehrere Monate nimmt, zahlt je Monat weniger und muss nicht ans Nachbestellen denken.": "One pack is 30 sticks \u2013 one a day, so exactly one month. Take several months and you pay less per month and never have to think about reordering.",
    "Preise und Verf\u00fcgbarkeit direkt aus dem Shop. Das Abo verl\u00e4ngert sich monatlich und ist jederzeit im Kundenkonto k\u00fcndbar oder pausierbar. Die Vorratspackungen sind einmalige Bestellungen.": "Prices and availability come straight from the shop. The subscription renews monthly and can be cancelled or paused any time in your account. The supply packs are one-off orders.",
    "Im Abo sparen": "Save with a subscription",
    "W\u00e4hle deine Kaufoption": "Choose how you buy",
    "Kaufoption w\u00e4hlen": "Choose purchase option",
    "Kaufoption ausw\u00e4hlen": "Choose purchase option",
    "Monatsvorrat im Abo": "Monthly supply on subscription",
    "Vorrat w\u00e4hlen": "Choose supply",
    "Laufzeit ausw\u00e4hlen": "Choose term",
    "Abo-Laufzeit ausw\u00e4hlen": "Choose subscription term",
    "Die gew\u00e4hlte Laufzeit umfasst die angezeigte Anzahl monatlicher Lieferungen und endet danach automatisch. Gesetzliche Rechte bleiben unber\u00fchrt.": "The chosen term covers the number of monthly deliveries shown and ends automatically afterwards. Statutory rights are unaffected.",
    " Sticks auf einmal": " sticks at once",
    "Was passt zu dir?": "What suits you?",
    "Dein Ziel": "Your goal",
    "Zunehmen": "Gaining weight",
    "Abnehmen": "Losing weight",
    "Magic Milk FOR X5 \u2014 ein Stick am Tag, in Wasser einger\u00fchrt, vor der Mahlzeit.": "Magic Milk FOR X5 \u2014 one stick a day, stirred into water, before the meal.",
    "Slim Weight Control \u2014 Kaffee, Tee und Kapseln aus derselben Reihe.": "Slim Weight Control \u2014 coffee, tea and capsules from the same line.",
    "Der Klassiker. Zehn pflanzliche Zutaten, neutral \u2014 mischt sich in alles.": "The classic. Ten plant-based ingredients, neutral \u2014 it mixes into anything.",
    "Die neuere Premium-Formel: alles aus Neutral, dazu Erdbeere.": "The newer premium formula: everything from Neutral, plus strawberry.",
    "Einmal Neutral, einmal Erdbeere. 60 Sticks \u2014 beide Sorten testen, ohne zweimal zu kaufen.": "One Neutral, one Strawberry. 60 sticks \u2014 try both without buying twice.",
    "Zwei Monate durchziehen statt nach vier Wochen nachlegen.": "See two months through instead of reordering after four weeks.",
    "Der gr\u00f6\u00dfte Vorrat: vier Monate am St\u00fcck.": "The largest supply: four months in one go.",
    "Drei Packungen Premium-Formel Erdbeere, 90 Sticks. Drei Monate ohne Nachbestellen.": "Three packs of the strawberry premium formula, 90 sticks. Three months with no reordering.",
    "Die Premium-Reihe von Florea. Fruchtig, ein Beutel morgens vor dem Essen.": "The premium line by Florea. Fruity, one sachet in the morning before eating.",
    "Premium-Linie Pro Milk ZeroTermo. Nussig und cremig statt neutral.": "Premium line Pro Milk ZeroTermo. Nutty and creamy instead of neutral.",
    "Kapseln statt Pulver. Nichts anr\u00fchren, geht auch unterwegs.": "Capsules instead of powder. Nothing to stir, works on the go.",
    "Die PLUS-Fassung der Kaffee-Linie. Eine Stufe \u00fcber dem Standard.": "The PLUS version of the coffee line. One step above the Standard.",
    "IRON, die Premium-Stufe der Kaffee-Linie.": "IRON, the premium tier of the coffee line.",
    "Die Special-Fassung von Florea \u2014 oberste Stufe der Kaffee-Reihe.": "The Special version by Florea \u2014 the top tier of the coffee line.",
    "Der Einstieg in die Kaffee-Linie. Ein Beutel am Tag.": "The entry point to the coffee line. One sachet a day.",
    "Ein Sachet aus der Packung nehmen, in 200\u2013250 ml Wasser einr\u00fchren, vor einer Mahlzeit trinken. Eine Box reicht 30 Tage.": "Take one sachet from the pack, stir it into 200\u2013250 ml of water and drink it before a meal. One box lasts 30 days.",
    "Sachet aufrei\u00dfen, in 200\u2013250 ml Wasser einr\u00fchren, vor der Mahlzeit trinken.": "Tear the sachet open, stir it into 200\u2013250 ml of water, drink before the meal.",
    "Zehn pflanzliche Zutaten, darunter Ingwer, Kamille und Zimt.": "Ten plant-based ingredients, among them ginger, chamomile and cinnamon.",
    "Vorrat f\u00fcr 30 Tage": "30 days of supply",
    "Drei\u00dfig einzelne Sachets in der Box \u2014 eines pro Tag.": "Thirty individual sachets in the box \u2014 one a day.",
    "Vier Siegel auf der Packung, damit du das Original erkennst.": "Four seals on the pack so you can spot the original.",
    "Anwendung in drei Schritten": "How to use it in three steps",
    "Schritt f\u00fcr Schritt": "Step by step",
    "Einen Beutel nehmen": "Take a sachet",
    "Drei\u00dfig einzelne Sachets liegen in der Box \u2014 Vorrat f\u00fcr einen Monat.": "Thirty individual sachets are in the box \u2014 a month\u2019s supply.",
    "Drei\u00dfig einzelne Sachets in der Box": "Thirty individual sachets in the box",
    "Vor der Mahlzeit trinken": "Drink before the meal",
    "Einmal am Tag, am besten morgens vor dem ersten Essen.": "Once a day, ideally in the morning before your first meal.",
    "Zehn pflanzliche Zutaten der Magic Milk Box": "Ten plant-based ingredients of the Magic Milk box",
    "Vier Hologramm-Siegel auf der Packung \u2014 daran erkennst du das Original.": "Four holographic seals on the pack \u2014 this is how you spot the original.",
    "Vier Hologramm-Siegel zur Echtheitspr\u00fcfung": "Four holographic seals for checking authenticity",
    "Vier Sorten im Wechsel": "Four flavours in rotation",
    "FOR X5 Magic Milk Strawberry \u2013 Geschmack Erdbeere, ein Stick pro Tag": "FOR X5 Magic Milk Strawberry \u2013 strawberry flavour, one stick a day",
    "FOR X5 Magic Milk Standard \u2013 Geschmack Neutral, ein Stick pro Tag": "FOR X5 Magic Milk Standard \u2013 neutral flavour, one stick a day",
    "ZeroTermo Pro-Milk Powder \u2013 Nuss und Creamy": "ZeroTermo Pro-Milk Powder \u2013 nut and creamy",
    "Florea Magic Fruit \u00fcber den Wolken mit fliegenden Erdbeeren": "Florea Magic Fruit above the clouds with flying strawberries",
    "Pro Milk ZeroTermo Packung auf einem Felsen im Meer, Olivenzweige im Vordergrund": "Pro Milk ZeroTermo pack on a rock in the sea, olive branches in the foreground",
    "Magic Milk Strawberry Packung und Seitenansicht vor gro\u00dfem Schriftzug": "Magic Milk Strawberry pack and side view in front of large lettering",
    "Florea Magic Fruit Cilekli vor dem Premium-Schriftzug": "Florea Magic Fruit Cilekli in front of the premium lettering",
    "Magic Milk FOR X5 auf einem gedeckten Tisch mit Brot, Erdbeeren und Milch": "Magic Milk FOR X5 on a laid table with bread, strawberries and milk",
    "Magic Milk FOR X5 auf einer Hantelbank im Fitnessstudio": "Magic Milk FOR X5 on a weight bench at the gym",
    "Magic Milk FOR X5 Stick, einzeln versiegelt": "Magic Milk FOR X5 stick, individually sealed",
    "Magic Milk FOR X5 Strawberry zwischen schwebenden Bausteinen": "Magic Milk FOR X5 Strawberry between floating blocks",
    "Alle Augen auf": "All eyes on",
    "Alle Augen auf Strawberry": "All eyes on Strawberry",
    "Zehn Zutaten von Magic Milk": "Ten ingredients of Magic Milk",
    "Die Kraft und Wirkung der Zutaten in Magic Milk": "The power and effect of the ingredients in Magic Milk",
    "Die Kraft und": "The power and",
    "Wirkung der Zutaten": "effect of the ingredients",
    "in Magic Milk": "in Magic Milk",
    "DER NEUE": "THE NEW",
    "Die meistgekaufte": "The best-selling one",
    "\u00dcber 1.000 Anwender & individuelle Erfahrungen": "Over 1,000 users & individual experiences",
    "Erfahrungsbericht": "Experience report",
    "Community-video": "Community video",
    "Magic Milk im Alltag": "Magic Milk in everyday life",
    "Direkt aus unserem Lager in Deutschland.": "Straight from our warehouse in Germany.",
    "Beladen fuer die Tour.": "Loaded for the run.",
    "Es geht direkt in den Wagen.": "Straight into the van.",
    "Bereit fuer die naechste Tour.": "Ready for the next run.",
    "Startklar fuer den Versand.": "Ready to ship.",
    "Neutral im Geschmack, der Klassiker.": "Neutral in taste, the classic.",
    "Ein Stick pro Tag.": "One stick a day.",
    "Zwei Packungen, ein Preis.": "Two packs, one price.",
    "\ud83e\udd5b Drei Sorten, eine Routine": "\ud83e\udd5b Three flavours, one routine",
    "So einfach geht die Zubereitung.": "That is how simple it is to make.",
    "Eine Million Follower auf TikTok.": "One million followers on TikTok.",
    "Echte Aufnahmen aus der Community.": "Real footage from the community.",
    "\ud83c\udfac Mitten im Alltag": "\ud83c\udfac Right in the middle of everyday life",
    "Noch eine echte Aufnahme.": "Another real clip.",
    "So laeuft es bei unseren Creatorn.": "This is how it goes with our creators.",
    "Noch ein Video aus der Community.": "Another video from the community.",
    "Ruecktmeldung eines Kunden.": "Feedback from a customer.",
    "Echte Rueckmeldung, dritte Packung bestellt.": "Real feedback, third pack ordered.",
    "Rueckmeldung aus dem Chat.": "Feedback from the chat.",
    "Rueckmeldung nach ein paar Tagen.": "Feedback after a few days.",
    "Antworten aus unserem Chat.": "Replies from our chat.",
    "\ud83e\udd5b Produkte": "\ud83e\udd5b Products",
    "Ein Gro\u00dfteil unserer Besteller stammt aus dem Ausland darunter USA, Kanada, UK, Schweiz, Skandinavien, Balkan-Region und weitere internationale M\u00e4rkte. Unser System ist exakt darauf optimiert, unterschiedliche Steuerzonen, Zollabwicklungen und Versandwege sauber zu trennen, sodass jeder Kunde den richtigen Preis und die schnellste Route erh\u00e4lt.": "A large share of our orders comes from abroad \u2014 among them the USA, Canada, the UK, Switzerland, Scandinavia, the Balkan region and other international markets. Our system is built to keep tax zones, customs handling and shipping routes cleanly apart, so every customer gets the right price and the fastest route.",
    "Unsere Produkte werden von Kunden aus Deutschland sowie aus verschiedenen europ\u00e4ischen und internationalen M\u00e4rkten bestellt. Dazu geh\u00f6ren unter anderem EU L\u00e4nder, die Schweiz, das Vereinigte K\u00f6nigreich, skandinavische L\u00e4nder, die Balkan Region, die USA, Kanada sowie weitere L\u00e4nder, sofern eine Lieferung im Checkout verf\u00fcgbar ist.": "Our products are ordered by customers in Germany and in various European and international markets. Among them are EU countries, Switzerland, the United Kingdom, the Nordic countries, the Balkan region, the USA, Canada and other countries, provided delivery is available at checkout.",
    "Mehr als 100 positive Kundenr\u00fcckmeldungen zeigen, dass viele unserer Kunden besonders unsere schnelle Lieferzeit innerhalb Deutschlands, die verst\u00e4ndliche Kommunikation und die professionelle Bestellabwicklung sch\u00e4tzen. Innerhalb Deutschlands betr\u00e4gt die Lieferzeit in der Regel 2 bis 3 Werktage nach Versand. Bei hoher Nachfrage, Vorbestellungen, Qualit\u00e4tspr\u00fcfungen oder internationalen Lieferungen kann es vereinzelt zu l\u00e4ngeren Bearbeitungszeiten kommen. Unser Ziel ist es, jede Bestellung zuverl\u00e4ssig, transparent und sorgf\u00e4ltig zu bearbeiten. Kunden erhalten alle wichtigen Informationen zur Bestellung, zum Versand und zur Sendungsverfolgung direkt per E Mail oder \u00fcber die angegebenen Kontaktwege.": "More than 100 positive customer replies show that many of our customers particularly value our fast delivery within Germany, our clear communication and our professional order handling. Within Germany delivery usually takes 2 to 3 working days after dispatch. During high demand, pre-orders, quality checks or international deliveries, processing can occasionally take longer. Our aim is to handle every order reliably, transparently and carefully. Customers receive all the important information about their order, the shipment and the tracking directly by email or through the contact channels given.",
    "Produktangaben": "Product details",
    "Mindesthaltbar bis": "Best before",
    "Einmaliger Kauf": "One-time purchase",
    "sparen": "save",
    "1 Jahr": "1 year",
    "So geht es": "Here is how",
    "In Wasser einr\u00fchren": "Stir into water",
    "200 bis 250 ml lauwarmes Wasser, kurz umr\u00fchren, fertig.": "200 to 250 ml of lukewarm water, a quick stir, done.",
    "Echtheit pr\u00fcfen": "Check authenticity",
    "Nettof\u00fcllmenge 120 g": "Net quantity 120 g",
    "je Packung \u2013 30 Sticks \u00e0 4 g, Vorrat f\u00fcr einen Monat": "per pack \u2013 30 sticks of 4 g, a month\u2019s supply",
    "Ein Stick t\u00e4glich in 200\u2013250 ml lauwarmem Wasser oder lauwarmer Milch einr\u00fchren, gut umr\u00fchren, langsam trinken": "Stir one stick a day into 200\u2013250 ml of lukewarm water or lukewarm milk, stir well, drink slowly",
    "Am besten morgens vor der ersten Mahlzeit": "Ideally in the morning before your first meal",
    "Die empfohlene t\u00e4gliche Verzehrmenge nicht \u00fcberschreiten": "Do not exceed the recommended daily intake",
    "Wichtige Hinweise:": "Important notes:",
    "Nahrungserg\u00e4nzungsmittel \u2013 kein Arzneimittel und kein Ersatz f\u00fcr eine ausgewogene Ern\u00e4hrung. F\u00fcr Erwachsene bestimmt. Personen mit Allergien, Unvertr\u00e4glichkeiten, Vorerkrankungen oder w\u00e4hrend Schwangerschaft und Stillzeit sollten vor der Anwendung \u00e4rztlichen Rat einholen. K\u00fchl, trocken und lichtgesch\u00fctzt lagern.": "Food supplement \u2013 not a medicine and no substitute for a balanced diet. Intended for adults. People with allergies, intolerances or pre-existing conditions, and those who are pregnant or breastfeeding, should seek medical advice before use. Store in a cool, dry place away from light.",
    "Vollst\u00e4ndige Angaben unter": "Full details at",
    "Inhaltsstoffe & Sicherheitshinweise": "Ingredients & safety information",
    "Versand aus Deutschland. Lieferung nach Deutschland, \u00d6sterreich und in die Schweiz, als Standard- oder Expressversand.": "Shipped from Germany. Delivery to Germany, Austria and Switzerland, by standard or express shipping.",
    "Kosten, Laufzeiten und L\u00e4nder stehen in den": "Costs, delivery times and countries are listed in the",
    "Versandbedingungen": "Shipping terms",
    ". Deine Sendung verfolgst du unter": ". You can follow your shipment at",
    "Entdecke unsere neue Slim Weight Control Kollektion sowie den beliebten neuen Erdbeer Geschmack von Magic Milk - nur f\u00fcr kurze Zeit und streng limitiert verf\u00fcgbar.": "Discover our new Slim Weight Control collection and the popular new strawberry flavour of Magic Milk \u2013 for a short time only and strictly limited.",
    "einfache Anwendung f\u00fcr optimale Ergebnisse": "simple to use for the best results",
    "Morgens nach dem Aufstehen, am besten 30-45 Minuten vor dem Fr\u00fchst\u00fcck ein Beutel Magic Milk in ein Glas geben.": "In the morning after getting up, ideally 30\u201345 minutes before breakfast, put one sachet of Magic Milk into a glass.",
    "Mit lauwarmem Wasser (ca. 200\u2013250 ml) auff\u00fcllen und gut umr\u00fchren, bis sich das Pulver vollst\u00e4ndig aufl\u00f6st.": "Top up with lukewarm water (approx. 200\u2013250 ml) and stir well until the powder has fully dissolved.",
    "Langsam trinken und energiegeladen in den Tag starten.": "Drink slowly and start the day with energy.",
    "/Monat oder erst in 30 Tagen bezahlen \u2013 mit": "/month or pay in 30 days \u2013 with",
    "mit Standard-Versand bestellst": "order with standard shipping",
    "Kauf auf Rechnung nach 30 Tagen oder Raten": "Pay by invoice after 30 days, or in instalments",
    "Einfache 14 Tage-R\u00fcckgabe Garantie": "Simple 14-day return guarantee",
    "haben sich das Produkt heute angesehen": "viewed this product today",
    "W\u00e4hle deine Laufzeit": "Choose your term",
    "Achtung vor F\u00e4lschungen": "Beware of fakes",
    "Abholung in K\u00f6ln & Berlin.": "Collection in Cologne & Berlin.",
    "Lieferung in 1-2 Tagen mit Sendungsverfolgungsnummer.": "Delivery in 1\u20132 days with a tracking number.",
    "Vier Packungen Premium-Formel Erdbeere, 120 Sticks. Der gr\u00f6\u00dfte Vorrat: vier Monate am St\u00fcck.": "Four packs of the strawberry premium formula, 120 sticks. The largest supply: four months in one go.",
    "Abnehmen leicht gemacht. F\u00fchl dich endlich wohler in deinem K\u00f6rper.": "Losing weight made easy. Feel better in your body at last.",
    "30% Rabatt auf alles \u2013 solange der Vorrat reicht.": "30% off everything \u2013 while stocks last.",
    "Starte jetzt und bring dich rechtzeitig in Form f\u00fcr den perfekten Sommer.": "Start now and get in shape in time for the perfect summer."
  };

  var R = [
    [/^Bild (\d+) zeigen$/, "Show image $1"],
    [/^Tag (\d+) von (\d+)$/, "Day $1 of $2"],
    [/^(\d+) von (\d+)$/, "$1 of $2"],
    [/^(.+) gespart$/, "$1 saved"],
    [/^(.+) g\u00fcnstiger$/, "$1 less"],
    [/^(.+) je Packung \u00b7 (\d+) Sticks \u00b7 vier Monate$/, "$1 per pack \u00b7 $2 sticks \u00b7 four months"],
    [/^(.+) je Packung \u00b7 alle vier Monate neu \u00b7 jederzeit k\u00fcndbar$/, "$1 per pack \u00b7 renewed every four months \u00b7 cancel any time"],
    [/^(\d[\d.,]*(?: ?K\+| Mio\.)?) Follower$/, "$1 followers"],
    [/^(@[\w.]+) \u00b7 (.+) Follower$/, "$1 \u00b7 $2 followers"],
    [/^In den Warenkorb \((.+)\)$/, "Add to cart ($1)"],
    [/^(\d+) Monate$/, "$1 months"],
    [/^JEDEN MONAT (\d+) % SPAREN$/, "SAVE $1 % EVERY MONTH"],
    [/^(\d+) Sticks \u00b7 (\d+) monatliche Lieferung$/, "$1 sticks \u00b7 $2 monthly delivery"],
    [/^(\d+) Sticks \u00b7 (\d+) Lieferungen$/, "$1 sticks \u00b7 $2 deliveries"],
    [/^(\d+) Sticks \u00b7 (\d+) Lieferung$/, "$1 sticks \u00b7 $2 delivery"],
    [/^(\d+) Monate? \u00b7 (\d+) Lieferungen?$/, "$1 months \u00b7 $2 deliveries"],
    [/^(.+) \u00b7 (\d+) gesamt$/, "$1 \u00b7 $2 in total"],
    [/^Je nach Charge: (.+)$/, "Depending on batch: $1"],
    [/^(\d+),(\d+) von (\d+)$/, "$1.$2 out of $3"],
    [/^F\u00fcr dich \u00b7 (\d+) Fragen$/, "For you \u00b7 $1 questions"],
    [/^Anwendung \u00b7 (\d+) Fragen$/, "How to use \u00b7 $1 questions"],
    [/^Inhalt & Sicherheit \u00b7 (\d+) Fragen$/, "Contents & safety \u00b7 $1 questions"],
    [/^Original & Preis \u00b7 (\d+) Fragen$/, "Original & price \u00b7 $1 questions"]
  ];

  var H = {
    "Zutaten laut Herstellerangaben: Ingwer, Milchpulver, Weizenkeime, Bockshornklee, Distel, L\u00f6wenzahn, Kreuzk\u00fcmmel, Zitrusschalen, Kamille und Zimt. Ma\u00dfgeblich sind immer die Angaben auf der Verpackung der jeweiligen Charge.": "<b>Ingredients as stated by the manufacturer:</b> ginger, <b>milk powder</b>, <b>wheat germ</b>, fenugreek, thistle, dandelion, cumin, citrus peel, chamomile and cinnamon. The details on the packaging of the respective batch always take precedence.",
    "Allergene: Enth\u00e4lt Milch und Weizen (Gluten). Das Produkt kann Kr\u00e4uter, Gew\u00fcrze und weitere Pflanzenbestandteile enthalten.": "<b>Allergens:</b> Contains <b>milk</b> and <b>wheat (gluten)</b>. The product may contain herbs, spices and other plant components."
  };

  /* Nachschlagen: erst die Tabelle, dann die Muster mit Zahlen darin.
     null heisst "kenne ich nicht" - dann bleibt der Text unangetastet. */
  function nachschlagen(roh) {
    var s = roh.replace(/\s+/g, ' ').trim();
    if (!s) return null;
    if (Object.prototype.hasOwnProperty.call(W, s)) return W[s];
    for (var i = 0; i < R.length; i++) {
      if (R[i][0].test(s)) return s.replace(R[i][0], R[i][1]);
    }
    return null;
  }

  window.mmT = function (t) {
    if (typeof t !== 'string') return t;
    var e = nachschlagen(t);
    return e === null ? t : e;
  };

  /* Wortkasten aus einer zerlegten Zeile? mm-textanim.js und die
     Aufdeck-Sektionen packen jedes Wort in ein eigenes span. Solche Bruchstuecke
     duerfen NICHT einzeln uebersetzt werden: sonst wird aus einem Satz, der als
     Ganzes im Woerterbuch steht, ein Mischmasch, weil ein Wort wie
     "Appetitanreger" fuer sich genommen auch ein Eintrag ist - und der ganze
     Satz danach nicht mehr gefunden wird. Genau das ist am 05.09.2026 beim
     Gegentest passiert ("Genau da setzt ein Appetite stimulant an").
     Ein ALLEIN stehendes Etikett in einem solchen span bleibt uebersetzbar:
     geprueft wird, ob der Kasten Geschwister derselben Art hat. */
  var KASTEN = /(?:^|\s)(?:mmW|mmTA|au-aufdeck__w|mmKaWort|mmKaGeist|mmKaEcht)(?:\s|$)/;

  function klasse(el) {
    var c = el.className;
    if (c && typeof c === 'object' && 'baseVal' in c) c = c.baseVal;   /* SVG */
    return typeof c === 'string' ? c : '';
  }

  function istBruchstueck(n) {
    var el = n.parentElement;
    for (var i = 0; i < 3 && el; i++, el = el.parentElement) {
      if (!KASTEN.test(klasse(el))) continue;
      var eltern = el.parentElement;
      if (!eltern) return false;
      var gleiche = 0;
      for (var k = 0; k < eltern.children.length; k++) {
        if (KASTEN.test(klasse(eltern.children[k])) && ++gleiche > 1) return true;
      }
      return false;
    }
    return false;
  }

  /* Ein Textknoten. Der Rand aus Leerzeichen bleibt erhalten - er traegt bei
     Inline-Text den Wortabstand, ohne ihn klebten Woerter aneinander. */
  function textknoten(n) {
    var roh = n.nodeValue;
    if (!roh || roh.length < 2) return;
    if (istBruchstueck(n)) return;
    var e = nachschlagen(roh);
    if (e === null) return;
    var vorn = roh.match(/^\s*/)[0];
    var hinten = roh.match(/\s*$/)[0];
    var neu = vorn + e + hinten;
    if (neu !== roh) n.nodeValue = neu;
  }

  var ATTRIBUTE = ['aria-label', 'alt', 'placeholder', 'title'];

  function attribute(el) {
    for (var i = 0; i < ATTRIBUTE.length; i++) {
      var a = ATTRIBUTE[i];
      if (!el.hasAttribute || !el.hasAttribute(a)) continue;
      var v = el.getAttribute(a);
      if (!v) continue;
      var e = nachschlagen(v);
      if (e !== null && e !== v) el.setAttribute(a, e);
    }
  }

  /* Skripte, Stilblaetter und Eingabefelder werden ausgelassen: dort steht
     Code oder etwas, das der Kunde selbst getippt hat. */
  var AUS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1 };

  /* Ganze Absaetze, deren innere Auszeichnung mituebersetzt werden muss.
     Der Grund steht bei H in woerter.py: zwischen zwei fett gesetzten
     Allergenen liegt als eigener Textknoten nur " und ". Ein Eintrag "und"
     wuerde jedes freistehende "und" der Seite treffen. Hier wird darum der
     Absatz als Ganzes getauscht - die vorgeschriebene Hervorhebung bleibt. */
  var INLINE = {
    SPAN: 1, B: 1, I: 1, EM: 1, STRONG: 1, A: 1,
    SMALL: 1, U: 1, BR: 1, SUP: 1, SUB: 1, MARK: 1
  };

  function nurInline(el) {
    if (!el.children) return false;   /* z. B. SVG-Knoten in aelteren Browsern */
    for (var i = 0; i < el.children.length; i++) {
      if (!INLINE[el.children[i].tagName]) return false;
    }
    return true;
  }

  function absatz(el) {
    if (!el || el.nodeType !== 1 || !nurInline(el)) return;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length < 12) return;
    if (!Object.prototype.hasOwnProperty.call(H, t)) return;
    el.innerHTML = H[t];
  }

  function durchgehen(wurzel) {
    if (!wurzel) return;
    if (wurzel.nodeType === 3) { textknoten(wurzel); return; }
    if (wurzel.nodeType !== 1) return;
    if (AUS[wurzel.tagName]) return;
    attribute(wurzel);
    /* Erst die Absaetze, dann die einzelnen Textknoten: danach steht dort
       Englisch und die Knoten laufen von selbst ins Leere. */
    absatz(wurzel);
    if (wurzel.querySelectorAll) {
      var k = wurzel.querySelectorAll('p,li,div,span,td,dd');
      for (var q = 0; q < k.length; q++) absatz(k[q]);
    }
    var w = document.createTreeWalker(
      wurzel,
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
      {
        acceptNode: function (n) {
          if (n.nodeType === 1 && AUS[n.tagName]) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) textknoten(n); else attribute(n);
    }
  }

  /* Der Beobachter haengt an der Wurzel, weil die Bausteine ihre Abschnitte an
     ganz unterschiedlichen Stellen einhaengen - teils bevor body fertig
     geparst ist. Er laeuft nur bei tatsaechlichen Aenderungen an. */
  var mo = new MutationObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      if (e.type === 'characterData') { textknoten(e.target); continue; }
      if (e.type === 'attributes') { attribute(e.target); continue; }
      for (var k = 0; k < e.addedNodes.length; k++) durchgehen(e.addedNodes[k]);
    }
  });
  mo.observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ATTRIBUTE
  });

  /* Durchgaenge ueber die schon vorhandene Seite: jetzt (was bis hierher
     geparst ist), nach DOMContentLoaded (die Bausteine mit defer) und nach
     load (Nachzuegler wie Upcart, das seinen Warenkorb spaeter nachreicht).
     Der Beobachter allein reicht nicht: Knoten, die vor ihm entstanden sind,
     meldet er nicht nach. */
  function ganzeSeite() { durchgehen(document.body || document.documentElement); }

  ganzeSeite();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ganzeSeite);
  }
  window.addEventListener('load', function () {
    ganzeSeite();
    window.setTimeout(ganzeSeite, 1200);
  });
})();
